import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		partnerList: [], //快递员列表
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获得快递员
		async getPartner({ commit }: any, params: any) {
			const res: any = await fetch({
				url: '/admin/partner',
				params
			})
			commit('setState', { key: 'partnerList', data: res.docs })
		},
	}
}